<template>
  <div class="gallary-wrap" v-if="isOpen">
    <div class="gallary">
      <div class="gallary-head">
        <h3>從素材圖庫中選取</h3>
      </div>

      <div class="gallary-body">
        <!-- filter category, search text -->
        <div class="gallary-selections">
          <div class="gallary-select mr-5">
            <v-select
              :items="categories"
              label="所有分類"
              solo
              style="height: 40px;"
              :menu-props="{
                'nudge-top': -45,
              }"
              :ripple="false"
              v-model="selectedCategory"
            ></v-select>
          </div>
          <div class="form-input-group">
            <div class="prepend-icon"><v-icon>search</v-icon></div>
            <input type="text" placeholder="搜尋" class="pl-42px" />
          </div>
        </div>
        <!-- gallary images -->
        <div class="gallary-images">
          <div
            v-for="img in images"
            :key="img.id"
            class="gallary-image"
            :style="{
              'background-image': `url(${addDomain(img.url)})`,
              'background-size': 'contain',
              'background-color': '#00000052',
            }"
            @click="selectImage(img)"
            @dblclick="confirmHandler"
          >
            <div class="check-icon" v-if="selectedImage.id === img.id">
              <v-icon color="white">check_circle</v-icon>
            </div>
          </div>
        </div>
      </div>

      <div class="gallary-foot">
        <button class="btn mr-10px w-100px" @click="cancelHandler">取消</button>
        <button class="btn btn-primary w-100px" @click="confirmHandler">
          確認
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    categories: [],
    images: [],
    selectedCategory: '',
    selectedImage: {},
  }),
  watch: {
    isOpen(val) {
      if (val) {
        this.getDirs().then((data) => {
          this.categories = data;
        });
      }
    },
    selectedCategory(val) {
      this.getFileByDir(val).then((data) => {
        this.images = data;
      });
    },
  },
  methods: {
    ...mapActions({
      getDirs: 'filesystem/getDirs',
      getFileByDir: 'filesystem/getFileByDir',
    }),
    addDomain(url) {
      if (url.indexOf('/storage/') === 0) {
        return `${process.env.VUE_APP_HOST}${url}`;
      }

      return url;
    },
    selectImage(image) {
      this.selectedImage = image;
    },
    cancelHandler() {
      this.$emit('gallary-close');
    },
    confirmHandler() {
      this.$emit('gallary-close');
      if (this.selectedImage.url) {
        this.$emit('setUrl', this.selectedImage.url);
      }
    },
  },
};
</script>

<style lang="scss">
.gallary-wrap {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(197, 197, 197, 0.5);
  z-index: 100;
}

.gallary {
  width: 720px;
  margin: 0 auto;
  margin-top: 40px;
  background-color: #fff;
  border-radius: 8px;

  &-head {
    padding: 20px;
    box-shadow: inset 0 -1px 0 0 #d7dee7;
  }

  &-body {
    height: 540px;
    overflow-y: auto;
  }
  // body_selection
  &-selections {
    display: flex;
    padding: 20px;
    .gallary-select {
      width: 117px;
      .v-input__slot {
        min-height: 0px !important;
        height: 40px !important;

        box-shadow: 0 1px 2px 0 rgba(4, 48, 71, 0.06),
          0 0 1px 0 rgba(4, 48, 71, 0.1) !important;
        border: solid 1px #d7dee7;
      }
    }
    .form-input-group {
      width: 523px;
      .prepend-icon {
        top: 45%;
      }
    }
  }
  // body_image
  &-images {
    display: flex;
    flex-wrap: wrap;
  }
  &-image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    height: 100px;
    background-position: center;
    background-size: cover;
    border-radius: 8px;
    margin-left: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    .check-icon {
      i {
        font-size: 15px;
      }
    }
  }

  &-foot {
    padding: 20px;
    text-align: right;
    text-align: right;
    box-shadow: inset 0 1px 0 0 #d7dee7;
  }
}
</style>
